import React from "react";
import { createRoot } from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import { ThemeProvider, createTheme } from "@mui/material/styles";
// import "leaflet/dist/leaflet.css";
// import { BrowserRouter } from "react-router-dom";

// Imports from the new file
import { client } from "./ApolloClient";
import { refreshAccessToken, startProactiveTokenRefresh } from "./auth/tokenRefresh";

import ScrollToTop from "@/ui/ScrollToTop";
import AppRoutes from "@/routes/AppRoutes";
import { BrowserRouter as Router } from "react-router-dom";
import { UserByIdDocument } from "@/__generated__/graphql";
import { mergeRefreshedUserData } from "./userDataSync";
import { clearCreateProjectDrafts } from "./legacyStorageCleanup";
const theme = createTheme();

import "./index.css";

/** =========================
 * Init auth on load (safe)
 * ========================= */
// GEOV-247: drop drafts left by the removed create-project wizard.
clearCreateProjectDrafts();

const initializeAuth = async () => {
 const ok =  await refreshAccessToken();
 if (!ok) return;

  // Keep the access token valid while the page is open, even if the user
  // is not doing anything, so REST requests like file uploads don't fail
  // because the token has expired.
 startProactiveTokenRefresh();
   // Re-sync the current user (esp. roles) so an existing session never
  // relies on a stale localStorage snapshot written at the last login.
  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return;
    const stored = JSON.parse(raw);
    const { _id } = stored;
    if (!_id) return;

    const { data } = await client.query({
      query: UserByIdDocument,
      variables: { id: _id },
      fetchPolicy: "network-only",
    });
    const freshUser = data?.userById;
    if (freshUser) {
      localStorage.setItem(
        "userData",
        JSON.stringify(mergeRefreshedUserData(stored, freshUser)),
      );
    }
  } catch {
    // Non-fatal: fall back to whatever is already stored.
  }
};


initializeAuth().finally(() => {
  const container = document.getElementById("root");
  if (!container)
    throw new Error("Root container with id 'root' was not found");

  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <ApolloProvider client={client}>
          <Router>
            <ScrollToTop />
            <AppRoutes />
          </Router>
        </ApolloProvider>
      </ThemeProvider>
    </React.StrictMode>,
  );
});
